<template>
  <v-container class="fill-height no-dealer-id-wrapper" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <div class="no-dealer-content">
          <v-icon size="64" color="warning" class="mb-4"> fas fa-exclamation-triangle </v-icon>
          <h2 class="mb-4">{{ $t('no-dealer-id.title') }}</h2>
          <p class="mb-4">{{ $t('no-dealer-id.description') }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NoDealerId',
  created() {
    this.setLocaleFromExternalId()
  },
  methods: {
    setLocaleFromExternalId() {
      const cognitoUser = this.$store.state.cognitoUser
      if (cognitoUser?.attributes) {
        const externalId = cognitoUser.attributes['custom:external_id']
        if (externalId) {
          // If starts with 120, it's a Portuguese external ID
          const locale = externalId.startsWith('120') ? 'pt' : 'es'
          this.$i18n.locale = locale
        }
      }
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({name: 'Login'})
      })
    },
  },
}
</script>

<style scoped lang="scss">
.no-dealer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h2 {
    font-family: 'ProximaNovaExCnSBold', system-ui, sans-serif;
    font-weight: normal;
    font-size: 28px;
    line-height: 1;
    margin: 0;
    text-transform: uppercase;
  }
}
</style>
